import { Component, OnInit } from '@angular/core'

@Component({
  templateUrl: './aprobar-caso-modal.component.html',
  styleUrls: ['./aprobar-caso-modal.component.scss']
})
export class DeteccionFraudesAprobarCasoModalComponent implements OnInit {
  constructor () {}
  ngOnInit() {}
}
